export const isPublicPageApp = () => {
  // @ts-ignore
  if (typeof useRuntimeConfig === 'function') {
    // Nuxt environment
    // @ts-ignore
    return useRuntimeConfig().public.appId === 'public';
  }
  return false;
};
